import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'
import {Socket, io} from 'socket.io-client';
import {defineCustomElements} from "@ionic/pwa-elements/loader";
import { LicenseInfo } from '@mui/x-data-grid-premium';
import { Capacitor } from "@capacitor/core";
import { CapacitorUpdater } from "@capgo/capacitor-updater";

// LicenseInfo.setLicenseKey("4f40021479de47dc4b1ff60364d61ae0Tz04OTg5MyxFPTE3NDY3MDcxMzkwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y");
LicenseInfo.setLicenseKey("018ac74494b33c3089efd5b8d55f4accTz0xMzAwNDQsRT0xODEyNjcxOTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI=");


//------ Capgo OTA 부팅 처리 ------------------------------------------------------------
//notifyAppReady()를 로그인/스플래시/네트워크와 무관하게 앱 부팅 직후 즉시 호출해야
//appReadyTimeout 내에 보고되어 자동 롤백이 발생하지 않는다.
//모든 호출은 네이티브에서만 동작하므로 isNativePlatform() 가드 필수(웹 스텁은 throw).

//Capgo 주요 이벤트 리스너 등록 (무음 실패 제거용 로깅). 7.8.9 지원 이벤트 전부.
function registerCapgoListeners() {
    const log = (evt: string) => (payload?: any) =>
        console.log(`[CAPGO][EVENT] ${evt} @${new Date().toISOString()}`, payload ? JSON.stringify(payload) : "");

    CapacitorUpdater.addListener("download", log("download"));
    CapacitorUpdater.addListener("downloadComplete", log("downloadComplete"));
    CapacitorUpdater.addListener("downloadFailed", log("downloadFailed"));
    CapacitorUpdater.addListener("updateAvailable", log("updateAvailable"));
    CapacitorUpdater.addListener("updateFailed", log("updateFailed"));
    CapacitorUpdater.addListener("noNeedUpdate", log("noNeedUpdate"));
    CapacitorUpdater.addListener("majorAvailable", log("majorAvailable"));
    CapacitorUpdater.addListener("appReloaded", log("appReloaded"));
    CapacitorUpdater.addListener("appReady", log("appReady"));
}

if (Capacitor.isNativePlatform()) {
    //appReady 이벤트까지 포착하기 위해 notifyAppReady 전에 리스너 등록
    registerCapgoListeners();

    (async () => {
        try {
            const res = await CapacitorUpdater.notifyAppReady();
            console.log(`[CAPGO] notifyAppReady OK @${new Date().toISOString()}`, JSON.stringify(res));
        } catch (e) {
            console.error(`[CAPGO] notifyAppReady FAILED @${new Date().toISOString()}`, e);
        }

        //부팅 시점 번들 상태 로깅
        try {
            const cur = await CapacitorUpdater.current();
            console.log(`[CAPGO][STATE] current`, JSON.stringify(cur));
        } catch (e) {
            console.error(`[CAPGO][STATE] current FAILED`, e);
        }
        try {
            const lst = await CapacitorUpdater.list();
            console.log(`[CAPGO][STATE] list`, JSON.stringify(lst));
        } catch (e) {
            console.error(`[CAPGO][STATE] list FAILED`, e);
        }
    })();
}
//------------------------------------------------------------------------------------


const socket: Socket = io("https://peetsunbae.com", {autoConnect : false, reconnection : true});

socket.open();

ReactDOM.render(
    <App socket={socket} />
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
defineCustomElements();
